import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=6c28d8bd&scoped=true"
import script from "./UploadModal.vue?vue&type=script&lang=js"
export * from "./UploadModal.vue?vue&type=script&lang=js"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=6c28d8bd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c28d8bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c28d8bd')) {
      api.createRecord('6c28d8bd', component.options)
    } else {
      api.reload('6c28d8bd', component.options)
    }
    module.hot.accept("./UploadModal.vue?vue&type=template&id=6c28d8bd&scoped=true", function () {
      api.rerender('6c28d8bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modals/UploadModal.vue"
export default component.exports